<template>
    <div>

        <config-main-title>
            Programa de Cuidado Coordenado
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Programa
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum programa de cuidado identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Programa'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-alto modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_cuidado_programa ) ? '' : 'Novo' }}
                            Programa
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_cuidado_programa">
                                #{{ item.id_cuidado_programa }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    placeholder="Informe o título do programa..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_cuidado_programa" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Sigla"
                                    type="text"
                                    :validate="validate"
                                    v-model="item.st_sigla" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    label="Cor"
                                    type="select"
                                    :optionsList="[
                                        { id: 'success', search: 'Verde' },
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'danger', search: 'Vermelho' },
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'dark', search: 'Preto' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'info', search: 'Ciano' },
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_cor" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Duração (meses)"
                                    placeholder="Indefinido"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_duracao_meses" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Idade Mínima do Paciente"
                                    placeholder="0"
                                    v-model="item.in_paciente_idade_minima" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Idade Máxima do Paciente"
                                    placeholder="999"
                                    v-model="item.in_paciente_idade_maxima" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="sexo"
                                    placeholder="Qualquer"
                                    label="Sexo do Paciente"
                                    v-model="item.ch_paciente_sexo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <az-sub-title title="Ações" class="mt-3">
                            <a class="card-link" href="#" @click.prevent="incluir_acao (item)">
                                <i class="fas fa-plus mr-2"></i>
                                Incluir Ação
                            </a>
                        </az-sub-title>

                        <div v-if="!item.acoes.length">
                            Nenhuma ação registrada.
                        </div>

                        <div v-else>
                            <template v-for="(acao, iax) in item.acoes">
                                <div class="form-row" :key="iax" v-show="acao.fl_ativo">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Ação..."
                                            required
                                            :validate="validate"
                                            v-model="acao.st_acao">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" @click="acao.fl_ativo = false">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Procedimento..."
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            service="procedimentos.index" 
                                            :optionsParm="{ ativos: true, agenda: true }"
                                            required
                                            :validate="validate"
                                            v-model="acao.procedimento" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input 
                                            sizing="sm" 
                                            label="Recorrente"
                                            type="checkbox-group" 
                                            v-model="acao.fl_recorrente" />
                                    </div>
                                    <div class="col col-12 col-md-1">
                                        <az-input 
                                            sizing="sm" 
                                            placeholder="Mês..."
                                            type="number" 
                                            required
                                            :validate="validate"
                                            v-model="acao.in_mes_inicio" />
                                    </div>
                                    <div class="col col-12 col-md-1" v-if="acao.fl_recorrente">
                                        <az-input 
                                            sizing="sm" 
                                            placeholder="Intervalo..."
                                            type="number" 
                                            required
                                            :validate="validate"
                                            v-model="acao.in_mes_intervalo" />
                                    </div>
                                    <div class="col col-12 col-md-1" v-if="acao.fl_recorrente">
                                        <az-input 
                                            sizing="sm" 
                                            placeholder="Término..."
                                            type="number" 
                                            :validate="validate"
                                            v-model="acao.in_mes_fim" />
                                    </div>
                                </div>
                            </template>

                            <br><br><br><br><br><br><br><br><br><br>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="cuidadoPrograma" :id="item.id_cuidado_programa" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_cuidado_programa ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
//import FiltroModel from '../shared/FiltroModel.vue';
//import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false, 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle, 
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let reg = this.$util.getregex(this.search);

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }
            
            return _.orderBy(opcoes, 'search');
        },

        lista_models_leads: function () { 
            return [
                { id: 'App\\azure\\marcacao', search: 'Faltosos' },
                { id: 'App\\azure\\orcamento', search: 'Orçamentos' },
                { id: 'App\\azure\\requisicao', search: 'Requisição' },
                { id: 'App\\azure\\atendimentoProcedimento', search: 'Retorno Previsto' },
                { id: 'App\\azure\\retornoAtendimento', search: 'Retorno Programado' },
            ];
        }
    },

    methods: { 
        incluir_acao (item) { 
            item.acoes.push({ 
                st_acao: "", 
                id_procedimento: "", 
                fl_ativo: true, 
                fl_recorrente: false,
                in_mes_inicio: "", 
                in_mes_intervalo: "",
                in_mes_fim: "", 
                procedimento: "", 
            });
        },

        remove_destino(item, idx) { 
            item.js_comunicacao.splice(idx,1);
        },

        incluir_destino() { 
            this.item.js_comunicacao.push({
                tipo: 'E',
                conta: "", 
            });
        },

        remover_destino(idx) { 
            this.item.js_comunicacao.splice(idx,1);
        },

        acessos(item) { 
          this.$refs.acessos.abrir('App\\azure\\filaLead', item.id_fila_lead);
        },
        remover_status (index) { 
            this.item.lista_status.splice(index,1);
        },

        add_status () { 
            if ( !this.status_para_incluir )
                return;

            if ( this.item.lista_status.findIndex(item => item.id_status_laudo == this.status_para_incluir.id_status_laudo) < 0 ) { 
                this.item.lista_status.push(this.status_para_incluir);
            }

            this.$nextTick(() => { 
                this.status_para_incluir = "";
            });
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },
        incluir_filtro(item) { 
            item.filtros.push({ 
                id_fila_lead_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },
        incluir () { 
            this.validate = false;

            let item = {
                st_cuidado_programa: "", 
                fl_ativo: true,
                st_observacoes: "", 
                acoes: [],
                ch_paciente_sexo: "", 
                in_paciente_idade_minima: "",
                in_paciente_idade_maxima: "", 
                in_duracao_meses: "", 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'cuidado_programas',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'cuidado_programas',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        
        toggle (item) { 
            this.$util.toggle(this, { 
                service: 'cuidado_programas',
                dados: item,
            });
        },

        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Programa de Cuidado Coordenado", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style scoped>
.modal-dialog-alto {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>